import styled from 'styled-components';

export const Wrapper = styled.div`
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
    height: 100dvh;

    video {
        position: absolute;
        inset: 0;
        width: 100%;
        height: 100%;
        object-fit: cover;
        pointer-events: none;
    }

    @media (max-width: 1000px) {
        video {
            height: 60vh;
            mask-image: linear-gradient(to bottom, rgba(0, 0, 0, 1) 75%, rgba(0, 0, 0, 0));
        }
    }
`;
